(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'mobile-platform-common-common-platform-sdk'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'mobile-platform-common-common-platform-sdk'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'mobile-platform-common-common-platform-sdk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'mobile-platform-common-common-platform-sdk'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'mobile-platform-common-common-platform-sdk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'mobile-platform-common-common-platform-sdk'.");
    }
    root['mobile-platform-common-common-platform-sdk'] = factory(typeof this['mobile-platform-common-common-platform-sdk'] === 'undefined' ? {} : this['mobile-platform-common-common-platform-sdk'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlinx-serialization-kotlinx-serialization-json']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.w4;
  var classMeta = kotlin_kotlin.$_$.y3;
  var setMetadataFor = kotlin_kotlin.$_$.x4;
  var VOID = kotlin_kotlin.$_$.e;
  var interfaceMeta = kotlin_kotlin.$_$.g4;
  var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var objectMeta = kotlin_kotlin.$_$.v4;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var Unit_instance = kotlin_kotlin.$_$.m2;
  var emptySet = kotlin_kotlin.$_$.g3;
  var equals = kotlin_kotlin.$_$.a4;
  var THROW_CCE = kotlin_kotlin.$_$.w5;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var getKClass = kotlin_kotlin.$_$.d;
  var arrayOf = kotlin_kotlin.$_$.i6;
  var createKType = kotlin_kotlin.$_$.a;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var isInterface = kotlin_kotlin.$_$.o4;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var getStringHashCode = kotlin_kotlin.$_$.e4;
  var hashCode = kotlin_kotlin.$_$.f4;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var toString = kotlin_kotlin.$_$.z4;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var JsonPrimitive_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
  var isNumber = kotlin_kotlin.$_$.q4;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a3;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.g;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var Collection = kotlin_kotlin.$_$.o2;
  var mapCapacity = kotlin_kotlin.$_$.j3;
  var coerceAtLeast = kotlin_kotlin.$_$.a5;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.m;
  var toString_0 = kotlin_kotlin.$_$.q6;
  var to = kotlin_kotlin.$_$.r6;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
  var Map = kotlin_kotlin.$_$.v2;
  var JsonNull_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var buildClassSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var JsonEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var defineProp = kotlin_kotlin.$_$.z3;
  //endregion
  //region block: pre-declaration
  setMetadataFor(EventSerializer, 'EventSerializer', classMeta, VOID, VOID, EventSerializer);
  setMetadataFor(Event, 'Event', interfaceMeta);
  setMetadataFor(EventBuilder, 'EventBuilder', interfaceMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EventDefinition, 'EventDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor(EventSerializer_0, 'EventSerializer', classMeta, VOID, VOID, EventSerializer_0);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SchemaDefinition, 'SchemaDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SinkArgument, 'SinkArgument', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SinkDefinition, 'SinkDefinition', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(EventAttributeValueSerializer, 'EventAttributeValueSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(EventImpl, 'EventImpl', classMeta, VOID, [Event], VOID, VOID, {0: $serializer_getInstance_3});
  //endregion
  function EventSerializer() {
    this.ur_1 = new EventSerializer_0();
  }
  protoOf(EventSerializer).vr = function (_set____db54di) {
    this.ur_1 = _set____db54di;
  };
  protoOf(EventSerializer).wr = function () {
    return this.ur_1;
  };
  protoOf(EventSerializer).serialize = function (event) {
    var result = this.ur_1.xr(event);
    return result;
  };
  function Event() {
  }
  function EventBuilder() {
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.zr_1 = [null, null, new LinkedHashSetSerializer($serializer_getInstance_0()), new LinkedHashSetSerializer($serializer_getInstance_2())];
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.careem.mobile.platform.analytics.event.EventDefinition', this, 4);
    tmp0_serialDesc.dj('version', false);
    tmp0_serialDesc.dj('name', false);
    tmp0_serialDesc.dj('schemaDefinitions', true);
    tmp0_serialDesc.dj('sinks', true);
    this.as_1 = tmp0_serialDesc;
  }
  protoOf($serializer).tc = function () {
    return this.as_1;
  };
  protoOf($serializer).fj = function () {
    var tmp0_cached = Companion_getInstance().zr_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], tmp0_cached[3]];
  };
  protoOf($serializer).bs = function (encoder, value) {
    var tmp0_desc = this.as_1;
    var tmp1_output = encoder.te(tmp0_desc);
    var tmp2_cached = Companion_getInstance().zr_1;
    tmp1_output.lf(tmp0_desc, 0, value.cs_1);
    tmp1_output.qf(tmp0_desc, 1, value.ds_1);
    if (tmp1_output.zf(tmp0_desc, 2) ? true : !equals(value.es_1, emptySet())) {
      tmp1_output.sf(tmp0_desc, 2, tmp2_cached[2], value.es_1);
    }
    if (tmp1_output.zf(tmp0_desc, 3) ? true : !equals(value.fs_1, emptySet())) {
      tmp1_output.sf(tmp0_desc, 3, tmp2_cached[3], value.fs_1);
    }
    tmp1_output.ue(tmp0_desc);
  };
  protoOf($serializer).uc = function (encoder, value) {
    return this.bs(encoder, value instanceof EventDefinition ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function EventDefinition(version, name, schemaDefinitions, sinks) {
    Companion_getInstance();
    schemaDefinitions = schemaDefinitions === VOID ? emptySet() : schemaDefinitions;
    sinks = sinks === VOID ? emptySet() : sinks;
    this.cs_1 = version;
    this.ds_1 = name;
    this.es_1 = schemaDefinitions;
    this.fs_1 = sinks;
  }
  function EventSerializer_0() {
  }
  protoOf(EventSerializer_0).xr = function (event) {
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    var value = event instanceof EventImpl ? event : THROW_CCE();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.wf();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(EventImpl), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    return this_0.zn(tmp$ret$1, value);
  };
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.gs_1 = [null, null, new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.careem.mobile.platform.analytics.event.SchemaDefinition', this, 3);
    tmp0_serialDesc.dj('name', false);
    tmp0_serialDesc.dj('type', false);
    tmp0_serialDesc.dj('requiredAttributesKeys', false);
    this.hs_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).tc = function () {
    return this.hs_1;
  };
  protoOf($serializer_0).fj = function () {
    var tmp0_cached = Companion_getInstance_0().gs_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2]];
  };
  protoOf($serializer_0).is = function (encoder, value) {
    var tmp0_desc = this.hs_1;
    var tmp1_output = encoder.te(tmp0_desc);
    var tmp2_cached = Companion_getInstance_0().gs_1;
    tmp1_output.qf(tmp0_desc, 0, value.js_1);
    tmp1_output.qf(tmp0_desc, 1, value.ks_1);
    tmp1_output.sf(tmp0_desc, 2, tmp2_cached[2], value.ls_1);
    tmp1_output.ue(tmp0_desc);
  };
  protoOf($serializer_0).uc = function (encoder, value) {
    return this.is(encoder, value instanceof SchemaDefinition ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function SchemaDefinition(name, type, requiredAttributesKeys) {
    Companion_getInstance_0();
    this.js_1 = name;
    this.ks_1 = type;
    this.ls_1 = requiredAttributesKeys;
  }
  protoOf(SchemaDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof SchemaDefinition))
      THROW_CCE();
    if (!(this.js_1 === other.js_1))
      return false;
    if (!(this.ks_1 === other.ks_1))
      return false;
    if (!equals(this.ls_1, other.ls_1))
      return false;
    return true;
  };
  protoOf(SchemaDefinition).hashCode = function () {
    var result = getStringHashCode(this.js_1);
    result = imul(31, result) + getStringHashCode(this.ks_1) | 0;
    result = imul(31, result) + hashCode(this.ls_1) | 0;
    return result;
  };
  protoOf(SchemaDefinition).toString = function () {
    return "SchemaDefinition(name='" + this.js_1 + "', type='" + this.ks_1 + "', requiredAttributesKeys='" + this.ls_1 + "')";
  };
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.careem.mobile.platform.analytics.event.SinkArgument', this, 2);
    tmp0_serialDesc.dj('name', false);
    tmp0_serialDesc.dj('rename', true);
    this.ms_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).tc = function () {
    return this.ms_1;
  };
  protoOf($serializer_1).fj = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_1).ns = function (encoder, value) {
    var tmp0_desc = this.ms_1;
    var tmp1_output = encoder.te(tmp0_desc);
    tmp1_output.qf(tmp0_desc, 0, value.os_1);
    if (tmp1_output.zf(tmp0_desc, 1) ? true : !(value.ps_1 == null)) {
      tmp1_output.uf(tmp0_desc, 1, StringSerializer_getInstance(), value.ps_1);
    }
    tmp1_output.ue(tmp0_desc);
  };
  protoOf($serializer_1).uc = function (encoder, value) {
    return this.ns(encoder, value instanceof SinkArgument ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function SinkArgument() {
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.qs_1 = [null, new LinkedHashSetSerializer($serializer_getInstance_1()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.careem.mobile.platform.analytics.event.SinkDefinition', this, 3);
    tmp0_serialDesc.dj('name', false);
    tmp0_serialDesc.dj('arguments', true);
    tmp0_serialDesc.dj('metadata', true);
    this.rs_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).tc = function () {
    return this.rs_1;
  };
  protoOf($serializer_2).fj = function () {
    var tmp0_cached = Companion_getInstance_1().qs_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2])];
  };
  protoOf($serializer_2).ss = function (encoder, value) {
    var tmp0_desc = this.rs_1;
    var tmp1_output = encoder.te(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().qs_1;
    tmp1_output.qf(tmp0_desc, 0, value.ts_1);
    if (tmp1_output.zf(tmp0_desc, 1) ? true : !(value.us_1 == null)) {
      tmp1_output.uf(tmp0_desc, 1, tmp2_cached[1], value.us_1);
    }
    if (tmp1_output.zf(tmp0_desc, 2) ? true : !(value.vs_1 == null)) {
      tmp1_output.uf(tmp0_desc, 2, tmp2_cached[2], value.vs_1);
    }
    tmp1_output.ue(tmp0_desc);
  };
  protoOf($serializer_2).uc = function (encoder, value) {
    return this.ss(encoder, value instanceof SinkDefinition ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function SinkDefinition() {
  }
  function serializeAny($this, value) {
    var tmp;
    if (value == null) {
      tmp = JsonNull_getInstance();
    } else {
      if (!(value == null) ? isInterface(value, Map) : false) {
        // Inline function 'kotlin.collections.associate' call
        var this_0 = value.n1();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap_init_$Create$(capacity);
        var tmp0_iterator = this_0.n();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.v();
          // Inline function 'kotlin.collections.plusAssign' call
          // Inline function 'com.careem.mobile.platform.analytics.internal.EventAttributeValueSerializer.serializeAny.<anonymous>' call
          var pair = to(toString_0(element.o1()), serializeAny(EventAttributeValueSerializer_getInstance(), element.p1()));
          destination.l1(pair.f9_1, pair.g9_1);
        }
        var mapContents = destination;
        tmp = new JsonObject(mapContents);
      } else {
        if (!(value == null) ? isInterface(value, Collection) : false) {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
          var tmp0_iterator_0 = value.n();
          while (tmp0_iterator_0.u()) {
            var item = tmp0_iterator_0.v();
            // Inline function 'com.careem.mobile.platform.analytics.internal.EventAttributeValueSerializer.serializeAny.<anonymous>' call
            var tmp$ret$3 = serializeAny(EventAttributeValueSerializer_getInstance(), item);
            destination_0.k(tmp$ret$3);
          }
          var arrayContents = destination_0;
          tmp = new JsonArray(arrayContents);
        } else {
          if (isNumber(value)) {
            tmp = JsonPrimitive_1(value);
          } else {
            if (!(value == null) ? typeof value === 'boolean' : false) {
              tmp = JsonPrimitive_0(value);
            } else {
              tmp = JsonPrimitive(toString(value));
            }
          }
        }
      }
    }
    return tmp;
  }
  function EventAttributeValueSerializer() {
    EventAttributeValueSerializer_instance = this;
    this.ws_1 = buildClassSerialDescriptor('Any', []);
  }
  protoOf(EventAttributeValueSerializer).tc = function () {
    return this.ws_1;
  };
  protoOf(EventAttributeValueSerializer).xs = function (encoder, value) {
    var jsonEncoder = isInterface(encoder, JsonEncoder) ? encoder : THROW_CCE();
    var jsonElement = serializeAny(this, value);
    jsonEncoder.wp(jsonElement);
  };
  protoOf(EventAttributeValueSerializer).uc = function (encoder, value) {
    return this.xs(encoder, !(value == null) ? value : THROW_CCE());
  };
  var EventAttributeValueSerializer_instance;
  function EventAttributeValueSerializer_getInstance() {
    if (EventAttributeValueSerializer_instance == null)
      new EventAttributeValueSerializer();
    return EventAttributeValueSerializer_instance;
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ys_1 = [null, new LinkedHashMapSerializer(StringSerializer_getInstance(), EventAttributeValueSerializer_getInstance())];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.careem.mobile.platform.analytics.internal.EventImpl', this, 2);
    tmp0_serialDesc.dj('eventDefinition', false);
    tmp0_serialDesc.dj('arguments', false);
    this.zs_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).tc = function () {
    return this.zs_1;
  };
  protoOf($serializer_3).fj = function () {
    var tmp0_cached = Companion_getInstance_2().ys_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), tmp0_cached[1]];
  };
  protoOf($serializer_3).at = function (encoder, value) {
    var tmp0_desc = this.zs_1;
    var tmp1_output = encoder.te(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().ys_1;
    tmp1_output.sf(tmp0_desc, 0, $serializer_getInstance(), value.bt_1);
    tmp1_output.sf(tmp0_desc, 1, tmp2_cached[1], value.ct_1);
    tmp1_output.ue(tmp0_desc);
  };
  protoOf($serializer_3).uc = function (encoder, value) {
    return this.at(encoder, value instanceof EventImpl ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function EventImpl(eventDefinition, arguments_0) {
    Companion_getInstance_2();
    this.bt_1 = eventDefinition;
    this.ct_1 = arguments_0;
  }
  protoOf(EventImpl).yr = function () {
    return this.bt_1;
  };
  protoOf(EventImpl).f5 = function () {
    return this.ct_1;
  };
  protoOf(EventImpl).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof EventImpl))
      THROW_CCE();
    if (!equals(this.bt_1, other.bt_1))
      return false;
    return equals(this.ct_1, other.ct_1);
  };
  protoOf(EventImpl).hashCode = function () {
    var result = hashCode(this.bt_1);
    result = imul(31, result) + hashCode(this.ct_1) | 0;
    return result;
  };
  //region block: post-declaration
  protoOf($serializer).gj = typeParametersSerializers;
  protoOf($serializer_0).gj = typeParametersSerializers;
  protoOf($serializer_1).gj = typeParametersSerializers;
  protoOf($serializer_2).gj = typeParametersSerializers;
  protoOf($serializer_3).gj = typeParametersSerializers;
  defineProp(protoOf(EventImpl), 'eventDefinition', function () {
    return this.yr();
  });
  defineProp(protoOf(EventImpl), 'arguments', function () {
    return this.f5();
  });
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.EventSerializer = EventSerializer;
    var $com = _.com || (_.com = {});
    var $com$careem = $com.careem || ($com.careem = {});
    var $com$careem$mobile = $com$careem.mobile || ($com$careem.mobile = {});
    var $com$careem$mobile$platform = $com$careem$mobile.platform || ($com$careem$mobile.platform = {});
    var $com$careem$mobile$platform$analytics = $com$careem$mobile$platform.analytics || ($com$careem$mobile$platform.analytics = {});
    var $com$careem$mobile$platform$analytics$event = $com$careem$mobile$platform$analytics.event || ($com$careem$mobile$platform$analytics.event = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = EventBuilder;
  _.$_$.b = EventDefinition;
  _.$_$.c = SchemaDefinition;
  _.$_$.d = EventImpl;
  //endregion
  return _;
}));
